import BaseApi from '../base/base'
import SpeakAudioForm from '../../forms/speak_audio'

export default class SpeakAudioApi extends BaseApi {
  constructor() {
    super()
    this.path = '/speak_audios'
  }

  async create(params: SpeakAudioForm): Promise<string> {
    this.path = '/speak_audios'
    const response = await this.postRequest(params)
    return response.data.s3Url
  }
}
